import { render, staticRenderFns } from "./Imagem.vue?vue&type=template&id=67229ce0&scoped=true&"
import script from "./Imagem.vue?vue&type=script&lang=js&"
export * from "./Imagem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67229ce0",
  null
  
)

export default component.exports